/* Jobs Controller
 ** Author: Soc-dfsk -30
 ** Version: 1.0
 ** Date 16/02/2017 */
'use strict';
App.controller('JobsCtrl', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', 'toastr', 'Api', '$log', '$localStorage', '$filter', 'commonService', '$uibModal', '$loading', '$document', '$sessionStorage', '$state', '$sce', 'sessionService','JobsClientService',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, toastr, Api, $log, $localStorage, $filter, commonService, $uibModal, $loading, $document, $sessionStorage, $state, $sce, sessionService, JobsClientService) {
        
        $scope.tabs = [
            {
                title: 'Find Jobs',
                content: "Tabs will become paginated if there isn't enough room for them.",
                url: 'views/findJobs.html',
            },
            {
                title: 'Applied Jobs',
                content: "You can swipe left and right on a mobile device to change tabs.",
                url: 'views/appliedJobs.html',
                disabled: true,
            },
            {
                title: 'Scheduled Jobs',
                content: "You can bind the selected tab via the selected attribute on the md-tabs element.",
                url: 'views/scheduleJobs.html',
                disabled: true,
            },
            {
                title: 'Jobs History',
                content: "If you set the selected tab binding to -1, it will leave no tab selected.",
                url: 'views/historyJobs.html',
                disabled: true,
            }];

        $scope.state = {
            "AL":"Alabama",
            "AK":"Alaska",
            "AS":"American Samoa",
            "AZ":"Arizona",
            "AR":"Arkansas",
            "CA":"California",
            "CO":"Colorado",
            "CT":"Connecticut",
            "DE":"Delaware",
            "DC":"District Of Columbia",
            "FM":"Federated States Of Micronesia",
            "FL":"Florida",
            "GA":"Georgia",
            "GU":"Guam",
            "HI":"Hawaii",
            "ID":"Idaho",
            "IL":"Illinois",
            "IN":"Indiana",
            "IA":"Iowa",
            "KS":"Kansas",
            "KY":"Kentucky",
            "LA":"Louisiana",
            "ME":"Maine",
            "MH":"Marshall Islands",
            "MD":"Maryland",
            "MA":"Massachusetts",
            "MI":"Michigan",
            "MN":"Minnesota",
            "MS":"Mississippi",
            "MO":"Missouri",
            "MT":"Montana",
            "NE":"Nebraska",
            "NV":"Nevada",
            "NH":"New Hampshire",
            "NJ":"New Jersey",
            "NM":"New Mexico",
            "NY":"New York",
            "NC":"North Carolina",
            "ND":"North Dakota",
            "MP":"Northern Mariana Islands",
            "OH":"Ohio",
            "OK":"Oklahoma",
            "OR":"Oregon",
            "PW":"Palau",
            "PA":"Pennsylvania",
            "PR":"Puerto Rico",
            "RI":"Rhode Island",
            "SC":"South Carolina",
            "SD":"South Dakota",
            "TN":"Tennessee",
            "TX":"Texas",
            "UT":"Utah",
            "VT":"Vermont",
            "VI":"Virgin Islands",
            "VA":"Virginia",
            "WA":"Washington",
            "WV":"West Virginia",
            "WI":"Wisconsin",
            "WY":"Wyoming"
        };
   
		$scope.convertRateFrequency = function(frequency) {
			let rateType;
	
			if (frequency === "MONTHLY") {
				rateType = "/Month";
			} else if (frequency === "YEARLY") {
				rateType = "/Year";
			} else if (frequency === "HOURLY") {
				rateType = "/hr";
			} else if (frequency === "WEEKLY") {
				rateType = "/Week";
			} else if (frequency === "DAILY") {
				rateType = "/Day";
			} else if (frequency === "") {
				rateType = "Variable";
			} else {
				rateType = " fixed";
			}
	
			return rateType;
		}

        //============show job location===========
        $scope.showJobLocation = function (data) {

            const address = [];
            
            data.locationType?.trim()
              ? address.push(data.locationType)
              : "";

            if (data.job?.workLocationAddress1 && data.job?.workLocationAddress1 !== 'null') {
                address.push(data.job.workLocationAddress1);
            } else if (data.workLocationAddress1 && data.workLocationAddress1 !== 'null') {
                address.push(data.workLocationAddress1);
            }
            
            if (data.job?.workLocationCity) {
                address.push(data.job.workLocationCity);
            } else if (data.workLocationCity) {
                address.push(data.workLocationCity);
            }

            if (data.job?.workLocationState) {
                address.push(data.job.workLocationState);
            } else if (data.workLocationState) {
                address.push(data.workLocationState);
            }

            let location = address.join(', ')
            return location;
        };

        this.updateData = function(data){
            const affiliations = _.get(data, 'affiliations', []);
            if(affiliations.length === 1){
                const { bannerURL, logoURL } = affiliations[0].organization.facility;
                $scope.bannerImage = bannerURL;
                $scope.logoImage = logoURL;
                $scope.$parent.logoImage = logoURL;
            }else{
                $scope.bannerImage = $localStorage.bannerImage;
                $scope.logoImage = $localStorage.logoImage;
                $scope.$parent.logoImage = $localStorage.logoImage; 
            }
            const currentStep = _.get(data, 'briefcase.currentStep', 0);
            if(currentStep >= 2){
                $scope.tabs.forEach((tab) => tab.disabled = false);
            }
            if(!$scope.$$phase){
                $scope.$apply();
            }
        }

        $scope.subscription = sessionService.professionalData.subscribe(this.updateData.bind(this));
        $scope.$on('$destroy', $scope.subscription);

        $scope.isNotMobile = (function() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
            return !check;
        })();

        $scope.selectedIndex = 0;
        $scope.$watch('selectedIndex', function (current, old) {
            if (current != undefined) {
                //$scope.selectedIndex = current;
                if (current === 0) {
                    $scope.$broadcast('findNewJobs', {
                        selectedIndex: current
                    });
                }
                if (current === 1) {
                    $scope.$broadcast('appliedJobs', {
                        selectedIndex: current
                    });
                }
                if (current === 2) {
                    $scope.$broadcast('scheduleJobs', {
                        selectedIndex: current
                    });
                }
                if (current === 3) {
                    $scope.$broadcast('historyJobs', {
                        selectedIndex: current
                    });
                }

            }
        });

        $scope.$watch($scope.tabs, function (newVal, oldVal) {}, true);
        $scope.addTab = function (title, view) {
            view = view || title + " Content View";
            tabs.push({
                title: title,
                content: view,
                disabled: false
            });
        };
        $scope.removeTab = function (tab) {
            var index = tabs.indexOf(tab);
            tabs.splice(index, 1);
        };
        $scope.list = [{
            "facalityName": 'Abc',
            "jobTitle": "Web Developer",
            "rate": "10",
            "dateShift": new Date(),
            "duration": 2,
        }, {
            "facalityName": 'Abc',
            "jobTitle": "Web Developer",
            "rate": "10",
            "dateShift": new Date(),
            "duration": 2,
        }, {
            "facalityName": 'Abc',
            "jobTitle": "Web Developer",
            "rate": "10",
            "dateShift": new Date(),
            "duration": 2,
        }, {
            "facalityName": 'Abc',
            "jobTitle": "Web Developer",
            "rate": "10",
            "dateShift": new Date(),
            "duration": 2,
        }];

        //============show job description===========
        $scope.showJobDescription = function (description) {
            description = description.replace(/\n\n/gi, '<br><br>');
            $scope.showDescription = $sce.trustAsHtml(description);
            ngDialog.open({
                template: 'showDescriptionModel',
                className: 'ngdialog-theme-default',
                showClose: true,
                closeByDocument: false,
                closeByEscape: false,
                scope: $scope,
                width: '70%',
            });
        };


        getDescriptionSize();
        window.addEventListener("resize", function () {
            getDescriptionSize()
        }, false);

        function getDescriptionSize() {
            var windowSize = $(window).width() + 15;
            //alert(windowSize);
            if (windowSize >= 1824) {
                $scope.descriptionSize = 450;
            } else if (windowSize >= 1424) {
                $scope.descriptionSize = 330;
            } else if (windowSize >= 1224) {
                $scope.descriptionSize = 300;
            } else if (windowSize >= 992) {
                $scope.descriptionSize = 200;
            } else if (windowSize >= 768) {
                $scope.descriptionSize = 150;
            } else {
                $scope.descriptionSize = 200;
            }
        }

    }
]);

App.controller('findJobsCtrl', ['$rootScope', '$scope', '$http', 'ngDialog', '$timeout', 'toastr', 'Api', '$q', 'commonService', '$document', '$loading', '$filter', 'mixPanelApi', '$state','$sessionStorage','$localStorage', '$location', '$stateParams', 'JobsClientService',
    function ($rootScope, $scope, $http, ngDialog, $timeout, toastr, Api, $q, commonService, $document, $loading, $filter, mixPanelApi, $state, $sessionStorage, $localStorage, $location, $stateParams, JobsClientService) {

        /* All Varibale delaration */
        $scope.myDate = new Date();
        $scope.endDate = new Date();
        $scope.selectDistance = commonService.selectDistance;
        $scope.invalidSearchAddress = false;
        var addressToLatLng = commonService.addressToLatLng;
        var nearby = true;
        var address = 'Plot No. 5, Madhya Marg, Sector 28 B, Chandigarh, 160028';
        var limitPerPage = 8;
        var skip = 0;
        var searchDate;
        $scope.skip = 0;
        $scope.jobCount;
        $scope.jobsNearActive = false;
        $scope.jobsFavActive = false;
        $scope.jobsAddressActive = false;
        $scope.jobsDistanceActive = false;
        $scope.jobsDateActive = false;
        $scope.isStartSelected = false;
        $scope.inCompleteBriefcaseError = "";
        $scope.errorRedirectionTab = "";

        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            limitPerPage: 8
        };
        $scope.closePopup = function () {
            ngDialog.closeAll();
        }
        $scope.search = {};
        $scope.search.addressSearch = ($stateParams.search != '' && $stateParams.search != null) ? $stateParams.search : '';
        $scope.sortType4 = 'rate'; // set the default sort type
        $scope.sortReverse4 = false; // set the default sort order
        $scope.sortType3 = 'startDate'; // set the default sort type
        $scope.sortReverse3 = false; // set the default sort order
        $scope.searchFish = ''; // set the default search/filter term

        $scope.search.myDate = null;
        $scope.search.endDate = null;
        $scope.isFavourite = false;

        $scope.stateJobs = [];
        $scope.isStateList = false;

        /* Get All jobs Api */
        var searchJobs = async function (param) {
            $loading.start('findJobs');

            // prepare payload
            const options = { status: 'OPEN' };
            if (param.sortByStartDate) {
                options.sortBy = 'startDate';
              } else if (param.sortByRate) {
                options.sortBy = 'rate';
              }
          
              if (param.dateRangeStart) {
                options.startDate = param.dateRangeStart.valueOf();
              }
          
              if (param.dateRangeEnd) {
                options.startDateTo = param.dateRangeEnd.valueOf();
              }
          
              if (param.searchBy == 1) {
                options.startDate = 'ASAP';
              } else if (param.searchBy == 2) {
                options.startDate = moment(new Date(param.jobStartDate)).utcOffset(parseInt(param.jobTimeZone)).toDate().valueOf();
              } 
          
              if (param.type) {
                options.type = param.type;
              }
          
              if (param.skip != undefined) {
                options.skip = param.skip;
              }
          
              if (param.limit != undefined) {
                options.limit = param.limit;
              }
          
              if (param.search) {
                options.search = param.search;
              }
          
              if (param.favorites) {
                options.favorite = true;
              }
          
              if (param.nearByRadius != undefined) {
                options.distance = param.nearByRadius;
              }

            const allJobs = [];
            let endTimeBufferMinutes = 0;
            try {
                endTimeBufferMinutes = (await JobsClientService.settings($localStorage['token'])).endTimeBufferMinutes;
            }
            catch(e) {
                console.error(e);
            }
            try {
                const result = await JobsClientService.listV1($localStorage['token'], options, endTimeBufferMinutes, ($localStorage['userId'] || ''), ($localStorage['userType'] || ''));
                if (result && result.list) {
                    for (var i = 0; i < result.list.length; i++) {
                        let job = result.list[i];
                    
                        var newRate = job.rateType == 'FLAT' ? job.rate : job.shiftLength * job.rate;
                        job['newRate'] = parseInt(newRate);
                        job['newStartDate'] = $filter('date')(job['startDate'], "MM/dd/yyyy h:mm a");
                        job['nursePool'] = (job.isMarketplace && job.isPRN) ? 'Both' : (job.isMarketplace ? 'Marketplace' : (job.isPRN ? 'PRNs' : 'Marketplace'));
                        job.rateType =  $scope.convertRateFrequency(job.rateType);
                        job['isDateSelected'] =  job.isDateSelected;

                        if (job.type == 'Permanent') {
                            job.shiftLength = job.shiftLength;
                        } else if (job.type == 'Per diem') {
                            job.shiftLength = (job.shiftLength > 1) ? job.shiftLength+' hrs' : job.shiftLength +' hr' ;
                        } else {
                            job.shiftLength = job.shiftLength +' '+ job.durationUnit;
                        }

                        job.chatEnabled = 0;
                        job.canDelegate = 0;
                        job.canEdit = 1;
                        job.showRate = 1;
                        allJobs.push(job);
                    }

                    $scope.allJobs = allJobs;
                    $scope.jobCount = result.count;
                    if (result.suggestions) {
                        for (const item of result.suggestions) {
                        item.specialties = item.specialties.join(', ');
                        item.hasLicense = item.hasLicense ? 1 : 0;
                        }
                
                        result.stateList = result.suggestions;
                        delete result.suggestions;
                    }
                    

                    if (result.stateList && (result.stateList.length > 0)) {
                        $scope.stateJobs = result.stateList;
                        for (var j = 0; j < $scope.stateJobs.length; j++) {
                            $scope.stateJobs[j].stateText = $scope.stateJobs[j].count + " in " + $scope.stateJobs[j].state;
                        }
                        $scope.isStateList = true;
                    } else {
                        $scope.isStateList = false;
                    }
                }
                $loading.finish('findJobs');
            }
            catch(e) {
                $loading.finish('findJobs');
                toastr.error(e.message);
            }
            finally {
                $scope.$applyAsync();
            }
        }

		$scope.convertRateFrequency = function(frequency) {
			let rateType;
	
			if (frequency === "MONTHLY") {
				rateType = "/Month";
			} else if (frequency === "YEARLY") {
				rateType = "/Year";
			} else if (frequency === "HOURLY") {
				rateType = "/hr";
			} else if (frequency === "WEEKLY") {
				rateType = "/Week";
			} else if (frequency === "DAILY") {
				rateType = "/Day";
			} else if (frequency === "") {
				rateType = "Variable";
			} else {
				rateType = " fixed";
			}
	
			return rateType;
		}

        $scope.updatePreferences = function () {
            $sessionStorage.isWorkPrefRedirect = true;
            $state.go('dashboard.profile');
        }

        $scope.searchNearMeJobs = function () {
            $scope.skip = 0;
            $scope.pagination.currentPage = 1;
            $scope.jobsNearActive = !$scope.jobsNearActive;
            var param = {
                limit: limitPerPage,
                skip: skip,
                sortByRate: $scope.sortReverse4,
                sortByStartDate: $scope.sortReverse3,
                match: true,
                nearby: $scope.jobsNearActive
            };
            if ($scope.search.workDistance) {
                param.nearByRadius = $scope.search.workDistance;
            }
            if ($scope.jobsFavActive) {
                param.favorites = true;
            }

            if (searchDate && searchDate.isValid()) {
                param.jobTimeZone = new Date().getTimezoneOffset();
                param.dateRangeStart = moment($scope.search.myDate, 'MM-DD-YYYY').toISOString();
                param.dateRangeEnd = moment(moment($scope.search.endDate, 'MM-DD-YYYY').add('days', 1)).toISOString();
            }

            var address = $scope.search.addressSearch;
            if (address && $scope.jobsAddressActive) {
                param.search = address;
            }
            if ($scope.jobsNearActive) {
                var promise = addressToLatLng($scope.$parent.user.city); //old case
                promise.then(function (res) {
                    //param.lat = res.lat;
                    //param.long = res.lng;
                    //param.sortByNearest =true;
                    param.sortByNearest = false;
                    searchJobs(param);
                }, function (reason) {
                    $scope.jobsNearActive = !$scope.jobsNearActive;
                    //toastr.error(reason.errorMsg);
                    param.nearby = false;
                    param.sortByNearest = false;
                    searchJobs(param);
                });
            } else {
                $scope.jobsDistanceActive = false;
                $scope.search.workDistance = '';
                param.nearby = false;
                param.sortByNearest = false;
                searchJobs(param);
            }

        }

        $scope.searchAllJobs = function (skip, limitPerPage) {
            var param = {
                limit: limitPerPage,
                skip: skip,
                match: true,
                sortByRate: $scope.sortReverse4,
                sortByStartDate: $scope.sortReverse3,
                nearby: $scope.jobsNearActive,
                sortByNearest: $scope.jobsNearActive
            };
            var promise = addressToLatLng($scope.$parent.user.address1 + ',' + $scope.$parent.user.city + ',' + $scope.$parent.user.state + ',' + $scope.$parent.user.zip);
            if ($scope.jobsFavActive) {
                param.favorites = true;
            }
            promise.then(function (res) {
                if ($scope.nearby) {
                    param.lat = res.lat;
                    param.long = res.lng;
                }
                searchJobs(param);
            }, function (reason) {
                //toastr.error(reason.errorMsg);
                param.nearby = false;
                param.sortByNearest = false;
                $scope.jobsNearActive = false;
                searchJobs(param);
            });
        };
        $scope.$on('findNewJobs', function (event, args) {
                //$scope.jobsNearActive = false;
                $scope.pagination.currentPage = 0;
                $scope.skip = 0;
                $scope.invalidSearchAddress = false;
                $scope.search = {};
                $scope.search.myDate = null;
                $scope.search.endDate = null;
                $scope.jobsFavActive = false;
                $scope.jobsAddressActive = false;
                $scope.jobsDistanceActive = false;
                $scope.jobsDateActive = false;
                $scope.jobsNearActive = false;
                $scope.searchAllJobs(skip, $scope.pagination.limitPerPage);
        });

        $scope.pageChanged = function (currentPage) {
            if (currentPage != 0) {
                $scope.skip = (currentPage - 1) * limitPerPage;
            } else {
                $scope.skip = 0;
            }
            $scope.getJobsWithFilters();
        }

        $scope.getJobsWithFilters = function () {
            var param = {
                limit: limitPerPage,
                skip: $scope.skip,
                sortByRate: $scope.sortReverse4,
                sortByStartDate: $scope.sortReverse3,
                match: true,
                nearby: $scope.jobsNearActive
            };
            if ($scope.search.workDistance) {
                $scope.jobsNearActive = true;
                param.nearByRadius = $scope.search.workDistance;
            }
            if ($scope.jobsFavActive) {
                param.favorites = true;
            }
            if ($scope.jobsFavActive) {
                param.favorites = true;
            }
            if (searchDate && searchDate.isValid()) {
                param.jobTimeZone = new Date().getTimezoneOffset();
                param.dateRangeStart = moment($scope.search.myDate, 'MM-DD-YYYY').toISOString();
                param.dateRangeEnd = moment(moment($scope.search.endDate, 'MM-DD-YYYY').add('days', 1)).toISOString();
            }
            var address = $scope.search.addressSearch;
            if (address && $scope.jobsAddressActive) {
                param.search = address;
            }
            if ($scope.jobsNearActive) {
                var promise = addressToLatLng($scope.$parent.user.city);
                promise.then(function (res) {
                    param.lat = res.lat;
                    param.long = res.lng;
                    param.sortByNearest = true;
                    searchJobs(param);
                }, function (reason) {
                    //toastr.error(reason.errorMsg);
                    param.nearby = false;
                    param.sortByNearest = false;
                    searchJobs(param);
                });
            } else {
                param.nearby = false;
                param.sortByNearest = false;
                searchJobs(param);
            }
        }

        $scope.openUnApproved = function(){
            dialogId = ngDialog.open({
                template: 'prnJobInfoPopupNew',
                className: 'ngdialog-theme-default documentation-dialog prn-dialog autoHeight incompleteApproval',
                closeByNavigation: true,
                showClose: false,
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false
            });
        }

        $scope.openApplyMessage = function(msg) {
					$scope.applyMessage = msg;

					dialogId = ngDialog.open({
						template: 'applyMessagePopup',
						className: 'ngdialog-theme-default documentation-dialog prn-dialog autoHeight incompleteApproval',
						closeByNavigation: true,
						showClose: false,
						scope: $scope,
						closeByDocument: false,
						closeByEscape: false
					});
				}
				
        $scope.onApplyMessageOK = function() {
					ngDialog.close();
				}

        $scope.onUnApprovedOK = function() {
            ngDialog.close();
            $loading.start('splash');
            if ($scope.errorRedirectionTab != "") {
                $location.path($scope.errorRedirectionTab);
                $scope.errorRedirectionTab = "";
            } else {
                $state.go('dashboard.profile');
            }
        }

        /* Apply job */
        $scope.applyJob = async function (currentPage, data) {
            var id = data.id;
            var intId = data.intId;
            
            $loading.start('findJobs');
            try {
                const result = await JobsClientService.apply($localStorage['token'], id);

                mixPanelApi.track(mixPanelApi.event().JOB_WORKFLOW, {
                    'Result': 'Success',
                    'Event on Job': 'APPLY',
                    'Job ID ': intId
                }); // apply track success
                $loading.finish('findJobs');
                if (data.type === "Per diem") {
                    toastr.success('Your availability is noted. We will notify you as soon as we are able to confirm the shift. Use the chat or call button to contact us.');
                } else {
                    toastr.success('Applied successfully.');
                }

								if (result.message) {
									$scope.openApplyMessage(result.message);
								}

                var diff = $scope.jobCount - $scope.skip;
                if (diff == 1 && $scope.jobCount > 1) {
                    $scope.skip = (currentPage - 2) * limitPerPage;
                    $scope.pagination.currentPage = currentPage - 1;
                } else {
                    if (currentPage != 0) {
                        $scope.skip = (currentPage - 1) * limitPerPage;
                    }
                }
                $scope.getJobsWithFilters();
            }
            catch(err) {
                $loading.finish('findJobs');
                if ( (err.name == 'BriefcaseIncompleteError') || 
                (err.name == 'LicenseMatchingError') || 
                (err.name == 'CertificationMatchingError')) {
                    $scope.inCompleteBriefcaseError = err.message;
                    //redirect to specific briefcase tab
                    $scope.errorRedirectionTab = err.location;
                    $scope.openUnApproved();
                } else {
                    toastr.error(err.message, {
                        allowHtml: true,
                        timeOut: 0,
                        closeButton: true,
                        closeHtml: '<button>&times;</button>'
                    });
                    mixPanelApi.track(mixPanelApi.event().JOB_WORKFLOW, {
                        'Result': 'Failure',
                        'Event on Job': 'APPLY',
                        'Job ID ': intId,
                        'Error': err.message
                    }); // apply track error
                }
            }
        }

        /* search jobs by date */

        $scope.searchJobsDate = function () {
            if (searchDate && searchDate.isValid()) {
                var param = {
                    limit: limitPerPage,
                    skip: skip,
                    match: true,
                    sortByRate: $scope.sortReverse4,
                    sortByStartDate: $scope.sortReverse3
                };
                var dat = searchDate.format('MM-DD-YYYY');
                param.jobDate = dat;
               // param.jobTimeZone = commonService.offSet();
                param.jobTimeZone = new Date().getTimezoneOffset();
                searchJobs(param);
            }
        }

        $scope.clearDates = function () {
            $scope.jobsDateActive = false;
            $scope.search.myDate = null;
            $scope.search.endDate = null;
            searchDate = '';
            $scope.isStartSelected = false;
            $scope.searchJobsByFilter(2);
        }
        /* search jobs by address */

        $scope.searchJobsAddress = function () {
            $scope.skip = 0;
            $scope.pagination.currentPage = 1;
            var param = {
                limit: limitPerPage,
                skip: skip,
                sortByRate: $scope.sortReverse4,
                sortByStartDate: $scope.sortReverse3,
                match: true,
                nearby: $scope.jobsNearActive
            };
            if ($scope.search.workDistance) {
                param.nearByRadius = $scope.search.workDistance;
            }
            if ($scope.jobsFavActive) {
                param.favorites = true;
            }
            if (searchDate && searchDate.isValid()) {
                param.jobTimeZone = new Date().getTimezoneOffset();
                param.dateRangeStart = moment($scope.search.myDate, 'MM-DD-YYYY').toISOString();
                param.dateRangeEnd = moment(moment($scope.search.endDate, 'MM-DD-YYYY').add('days', 1)).toISOString();
            }
            var address = $scope.search.addressSearch;

            if (address && !$scope.jobsAddressActive) {
                param.search = address;
                $scope.jobsAddressActive = !$scope.jobsAddressActive;
            } else {
                $scope.jobsAddressActive = false;
                $scope.search.addressSearch = '';
                // $scope.jobsAddressActive = !$scope.jobsAddressActive;
            }
            if ($scope.jobsNearActive) {
                var promise = addressToLatLng($scope.$parent.user.city);
                promise.then(function (res) {
                    param.lat = res.lat;
                    param.long = res.lng;
                    param.sortByNearest = true;
                    param.nearby = true;
                    searchJobs(param);
                }, function (reason) {
                    param.nearby = false;
                    param.sortByNearest = false;
                    searchJobs(param);
                    //toastr.error(reason.errorMsg);
                });
            } else {
                param.nearby = false;
                param.sortByNearest = false;
                searchJobs(param);
            }

        }
        $scope.searchJobsAddress()
        /* search jobs by filter */

        $scope.searchJobsByFilter = function (type) {
            $scope.skip = 0;
            $scope.pagination.currentPage = 1;
            var param = {
                limit: limitPerPage,
                skip: skip,
                sortByRate: $scope.sortReverse4,
                sortByStartDate: $scope.sortReverse3,
                match: true,
                nearby: $scope.jobsNearActive
            };
            if ($scope.search.workDistance) {
                if (type == 1) {
                    $scope.jobsDistanceActive = !$scope.jobsDistanceActive;
                }
                if ($scope.jobsDistanceActive) {
                    param.nearByRadius = $scope.search.workDistance;
                    $scope.jobsNearActive = true;
                } else {
                    $scope.search.workDistance = '';
                }

            }
            if (type == 3) {
                if (!$scope.jobsFavActive) {
                    $scope.jobsFavActive = !$scope.jobsFavActive;
                    param.favorites = true;
                } else {
                    param.favorites = false;
                    $scope.jobsFavActive = !$scope.jobsFavActive;
                }
            } else {
                if ($scope.jobsFavActive) {
                    param.favorites = true;
                }
            }
            if (searchDate && searchDate.isValid()) {
                if (type == 2) {
                    //$scope.jobsDateActive = !$scope.jobsDateActive;
                }
                if ($scope.jobsDateActive) {
                    param.jobTimeZone = new Date().getTimezoneOffset();
                    param.dateRangeStart = moment($scope.search.myDate, 'MM-DD-YYYY').toISOString();
                    param.dateRangeEnd = moment(moment($scope.search.endDate, 'MM-DD-YYYY').add('days', 1)).toISOString();
                } else {
                    $scope.search.myDate = null;
                    $scope.search.endDate = null;
                    searchDate = '';
                }
            }

            var address = $scope.search.addressSearch;
            if (address && $scope.jobsAddressActive) {
                param.search = address;
            }
            if ($scope.jobsNearActive) {
                var promise = addressToLatLng($scope.$parent.user.city);
                promise.then(function (res) {
                    param.lat = res.lat;
                    param.long = res.lng;
                    param.sortByNearest = true;
                    param.nearby = true;
                    searchJobs(param);
                }, function (reason) {
                    //toastr.error(reason.errorMsg);
                    param.nearby = false;
                    param.sortByNearest = false;
                    searchJobs(param);
                });
            } else {
                param.nearby = false;
                param.sortByNearest = false;
                searchJobs(param);
            }

        }

        $scope.openJobDetail = function () {
            $scope.jobOpen = !$scope.jobOpen;
        }
        //setDateTimeToMidnight

        $scope.sortByRate = function () {
            $scope.sortReverse4 = !$scope.sortReverse4;
            var orderByExpression = [];
            orderByExpression.push('newRate');
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse4);

        };
        $scope.sortByDate = function () {
            $scope.sortReverse3 = !$scope.sortReverse3;
            var orderByExpression = [];
            orderByExpression.push('newStartDate');
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse3);
        };
        $scope.openJobDetail = function (index) {
            //$scope.isFavourite = $scope.allJobs[index].hospital.isFavorite;
            var target = angular.element('#findJobsImg' + index);
            if (target.hasClass('arrow-image')) {
                target.removeClass('arrow-image');
                target.addClass('arrow-image-down');
            } else {
                target.removeClass('arrow-image-down');
                target.addClass('arrow-image');
            }

            $('.arrow-image-down').not('#findJobsImg' + index).removeClass('arrow-image-down').addClass('arrow-image');
            $('.close-job').not('#otherDetails' + index).removeClass('in');

        }

        /* Set job as favorite */
        $scope.updateFavourite = async function (id) {
            $scope.isFavourite = !$scope.isFavourite;
            var token = $localStorage['token'];
            try {
                await JobsClientService.favorite(token, id);
                if ($scope.jobsFavActive) {
                    var currentPage = $scope.pagination.currentPage;
                    var diff = $scope.jobCount - $scope.skip;
                    if (diff == 1 && $scope.jobCount > 1) {
                        $scope.skip = (currentPage - 2) * limitPerPage;
                        $scope.pagination.currentPage = currentPage - 1;
                    } else {
                        if (currentPage != 0) {
                            $scope.skip = (currentPage - 1) * limitPerPage;
                        }
                    }
                }
                $scope.getJobsWithFilters();
            }
            catch(err) {
                toastr.error(err.message);
            }
        }

        // callback for datepicker
        var start = moment();

        $scope.invokeDatePicker = function (id) {
            setTimeout(function () {
                var dateElement = document.getElementById(id);
                dateElement.click();
              }, 0);
        }

        function cb4(start, end) {
            $scope.$apply(function () {
                $scope.search.myDate = $filter('date')(start.toDate(), "MM-dd-yyyy");
                if ($scope.jobsDateActive && $scope.search.endDate && $scope.search.endDate != '' ) {
                    $scope.searchJobsByFilter(2);
                } else {
                    $scope.isStartSelected = true;
                }
            });
        }

        //  datepicker function
        $scope.openDatePicker4 = function (cls) {
            $('.bt-datepicker4').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                parentEl: '.' + cls,
                date: start,
                minDate: start,
                maxDate: searchDate?searchDate:'',
                "opens": "left",

                "locale": {
                    format: 'MM-DD-YYYY'
                },
                autoclose: true
            }, cb4);

        }

        function cb5(start, end) {
            $scope.$apply(function () {
                searchDate = start;
                $scope.jobsDateActive = true;
                $scope.search.endDate = $filter('date')(start.toDate(), "MM-dd-yyyy");
                if ($scope.search.myDate && $scope.search.myDate != '') {
                    $scope.searchJobsByFilter(2);
                } else {
                    $scope.isStartSelected = false;
                }
            });
        }
        //  datepicker function
        $scope.openDatePicker5 = function (cls) {
            console.log('datepicker5');
            $('.bt-datepicker5').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                parentEl: '.' + cls,
                date: $scope.search.endDate,
                minDate: $scope.search.myDate,
                "opens": "left",

                "locale": {
                    format: 'MM-DD-YYYY'
                },
                autoclose: true
            }, cb5);

        }
        // fuction call when search date enter by user
        $scope.enterdate = function () {
            if ($scope.search.myDate) {
                if ($scope.jobsDateActive && $scope.search.endDate && $scope.search.endDate != '' ) {
                    $scope.searchJobsByFilter(2);
                } else {
                    $scope.isStartSelected = true;
                }
            }
        }

        // fuction call when search date enter by user
        $scope.enterEnddate = function () {
            if ($scope.search.endDate) {
                searchDate = moment($scope.search.endDate);
                $scope.jobsDateActive = true;
                if ($scope.search.myDate && $scope.search.myDate != '') {
                    $scope.searchJobsByFilter(2);
                } else {
                    $scope.isStartSelected = false;
                }
            }
        }

    }
]);

App.controller('appliedJobsCtrl', ['$rootScope', '$scope', '$http', 'ngDialog', '$timeout', 'toastr', 'Api', '$q', 'commonService', '$document', '$loading', '$filter', 'mixPanelApi','$localStorage', 'sessionService', 'JobsClientService',
    function ($rootScope, $scope, $http, ngDialog, $timeout, toastr, Api, $q, commonService, $document, $loading, $filter, mixPanelApi,$localStorage, sessionService, JobsClientService) {
        /* All Varibale delaration */
        var limitPerPage = 8;
        var skip = 0;
        var dialogId;
        var shareDocementAppId;
        var shareDocumentIndex;

        this.updateData = function(data){
            $scope.resumeShared = !!_.get(data, 'summary.resumeFileUrl');
            $scope.driverLicense = !!_.get(data,'summary.driversLicense');
            $scope.vehicleInsurance = !!_.get(data,'briefcase.vehicleInsurance.fileUrl');
            $scope.liabilityInsurance = !!_.get(data, 'briefcase.liabilityInsurance.fileUrl');
            const healthDocuments = _.get(data, 'briefcase.healthDocuments', []);
            $scope.vaccinationDocument = healthDocuments.find(({ name }) => name === 'Other vaccination');
            $scope.drugTest = healthDocuments.find(({ name }) => name === 'Drug test');
            $scope.TBTest = healthDocuments.find(({ name }) => name === 'TB test');
            $scope.sharedListAdditionalCertification = [];
            $scope.sharedListCertification = [];
            var addCert = false;
            angular.forEach(_.get(data,'briefcase.additionalCertifications', []), function ({name}) {
                addCert = true;
                $scope.sharedListAdditionalCertification.push({
                    name,
                    'value': false
                });
            });
            $scope.additionalCertDocument = addCert;
            var cert = false;
            angular.forEach(_.get(data, 'nurse.certifications', []), function ({ name }) {
                cert = true;
                $scope.sharedListCertification.push({
                    'name': [],
                    'value': false
                });
            });
            $scope.certDocument = cert;
        }

        $scope.subscription = sessionService.professionalData.subscribe(this.updateData.bind(this));
        $scope.$on('$destroy', $scope.subscription);

        $scope.skip = 0;
        $scope.jobCount;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            limitPerPage: 8
        };
        $scope.search = {};
        $scope.sortType = 'newRate'; // set the default sort type
        $scope.sortReverse = false; // set the default sort order
        $scope.sortType2 = 'newStartDate'; // set the default sort type
        $scope.sortReverse2 = false; // set the default sort order
        $scope.searchFish = ''; // set the default search/filter term
        $scope.isFavourite = false;
        $scope.document = {};
        $scope.$on('appliedJobs', function (event, args) {
            $scope.pagination.currentPage = 0;
            $scope.skip = 0;
            $scope.searchAllJobs(skip, $scope.pagination.limitPerPage);
        });      
        
        /* Get All jobs Api */
        var searchJobs = async function (param) {
            $loading.start('findJobs');
          
            const options = { status: 'APPLIED' };
            if (param.skip != undefined) {
                options.skip = param.skip;
            }
        
            if (param.limit != undefined) {
                options.limit = param.limit;
            }
            let endTimeBufferMinutes = 0;
            try {
                endTimeBufferMinutes = (await JobsClientService.settings($localStorage['token'])).endTimeBufferMinutes;
            }
            catch(e) {
                console.error(e);
            }
            try {
                const allJobs = [];
                const result = await JobsClientService.listV1($localStorage['token'], options, endTimeBufferMinutes, ($localStorage['userId'] || ''), ($localStorage['userType'] || ''));
                if (result && result.list) {
                    $scope.jobCount = result.count || 0;
                    for (let i = 0; i < result.list.length; i++) {
                        let jobObj = result.list[i];

                        var newRate = jobObj.job.rateType == 'FLAT' ? jobObj.job.rate : jobObj.job.shiftLength * jobObj.job.rate;
                        jobObj['newRate'] = parseInt(newRate);
                        jobObj['newStartDate'] = $filter('date')(jobObj.job.startDate, "MM/dd/yyyy h:mm a");
                        jobObj['nursePool'] = (jobObj.isMarketplace && jobObj.isPRN) ? 'Both' : (jobObj.isMarketplace ? 'Marketplace' : (jobObj.isPRN ? 'PRNs' : 'Marketplace'));
                        jobObj.rateType =  $scope.convertRateFrequency(jobObj.job.rateType);
                        jobObj.isDateSelected =  jobObj.job.isDateSelected;

                        if (jobObj.job.type == 'Permanent') {
                            jobObj.shiftLength = jobObj.job.shiftLength;
                        } else if (jobObj.job.type == 'Per diem') {
                            jobObj.shiftLength = (jobObj.job.shiftLength > 1) ? jobObj.job.shiftLength +' hrs' : jobObj.job.shiftLength + ' hr' ;
                        } else {
                            jobObj.shiftLength = jobObj.job.shiftLength + ' ' + jobObj.job.durationUnit;
                        }

                        allJobs.push(jobObj)
                    }

                    $scope.allJobs = allJobs;
                }
                $loading.finish('findJobs');
            }
            catch(err) {
                $loading.finish('findJobs');
                toastr.error(err.message);
            }
            finally {
                $scope.$applyAsync();
            }
        };

        $scope.searchAllJobs = function (skip, limitPerPage) {
            var param = {
                limit: limitPerPage,
                skip: skip
            };
            searchJobs(param);
        }
        $scope.pageChanged = function (currentPage) {
            //console.log(currentPage);
            if (currentPage != 0) {
                $scope.skip = (currentPage - 1) * limitPerPage;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            } else {
                $scope.skip = 0;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            }
            $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
        }
        var unapplyJobId;
        /* confirm UnApply job */
        $scope.confirmUnapplyJob = function (data) {
            unapplyJobId = data.job.id;
            $scope.unapplyInitId = data.user.id;
            dialogId = ngDialog.open({
                template: 'unApply-confirm-dialog',
                className: 'ngdialog-theme-default unApply-confirm-dialog',
                closeByNavigation: true,
                showClose: false,
                scope: $scope
            });
        }


        /* Apply job */
        $scope.unApplyJob = async function (currentPage) {
            $scope.closePopup();
            $loading.start('findJobs');
            try {
                await JobsClientService.withdraw($localStorage['token'], unapplyJobId);
                mixPanelApi.track(mixPanelApi.event().JOB_WORKFLOW, {
                    'Result': 'Success',
                    'Event on Job': 'UNAPPLY',
                    'Job ID ': $scope.unapplyInitId
                });

                $loading.finish('findJobs');
                toastr.success('Unapplied successfully.');
                var diff = $scope.jobCount - $scope.skip;
                if (diff == 1 && $scope.jobCount > 1) {
                    $scope.skip = ($scope.pagination.currentPage - 2) * limitPerPage;
                    $scope.pagination.currentPage = $scope.pagination.currentPage - 1;
                } else {
                    if ($scope.pagination.currentPage != 0) {
                        $scope.skip = ($scope.pagination.currentPage - 1) * limitPerPage;
                    } else {
                        $scope.skip = 0;
                    }
                }
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            }
            catch(err) {
                $loading.finish('findJobs');
                toastr.error(err.message);
                mixPanelApi.track(mixPanelApi.event().JOB_WORKFLOW, {
                    'Result': 'Failure',
                    'Event on Job': 'UNAPPLY',
                    'Job ID ': $scope.unapplyInitId,
                    'Error': err.message
                });
            }
        }

        $scope.closePopup = function () {
            ngDialog.close(dialogId);
        };


        $scope.shareDocumentOpen = function (data, index) {
            shareDocementAppId = data.job.id;
            shareDocumentIndex = index;
            $scope.document.w9 = $scope.allJobs[index].W9Shared ? true : false;
            $scope.document.driverLicence = $scope.allJobs[index].driverLicenseShared ? true : false;
            $scope.document.resume = $scope.allJobs[index].resumeShared ? true : false;
            $scope.document.motorVehicleInsurance = $scope.allJobs[index].vehicleInsuranceShared ? true : false;
            $scope.document.liabilityInsurance = $scope.allJobs[index].liabilityInsuranceShared ? true : false;
            $scope.document.vaccinationShared = $scope.allJobs[index].vaccinationShared ? true : false;
            $scope.document.drugTestDocumentShared = $scope.allJobs[index].drugTestDocumentShared ? true : false;
            $scope.document.xRayDocumentShared = $scope.allJobs[index].xRayDocumentShared ? true : false;
            if ($scope.allJobs[index].certificationsShared != null && $scope.allJobs[index].certificationsShared != 0 && $scope.allJobs[index].certificationsShared.length != 0) {
                angular.forEach($scope.allJobs[index].certificationsShared, function (col) {
                    for (var k = 0; k < $scope.sharedListCertification.length; k++) {
                        if (col == $scope.sharedListCertification[k].name)
                            $scope.sharedListCertification[k].value = true;
                    }
                })
            }
            if ($scope.allJobs[index].additionalCertificationsShared != null && $scope.allJobs[index].additionalCertificationsShared != 0 && $scope.allJobs[index].additionalCertificationsShared.length != 0) {
                angular.forEach($scope.allJobs[index].additionalCertificationsShared, function (col) {
                    for (var k = 0; k < $scope.sharedListAdditionalCertification.length; k++) {
                        if (col == $scope.sharedListAdditionalCertification[k].name)
                            $scope.sharedListAdditionalCertification[k].value = true;
                    }
                })
            }
            dialogId = ngDialog.open({
                template: 'share-document-dialog',
                className: 'ngdialog-theme-default share-document-dialog',
                closeByNavigation: true,
                scope: $scope
            });
        };
        $scope.shareDocumentClose = async function () {
            var cert = [],
                addCert = [];
            angular.forEach($scope.sharedListCertification, function (col, p) {
                if (col.value) {
                    cert.push(col.name);
                    $scope.sharedListCertification[p].value = false;
                }
            });
            angular.forEach($scope.sharedListAdditionalCertification, function (col, p) {
                if (col.value) {
                    addCert.push(col.name);
                    $scope.sharedListAdditionalCertification[p].value = false;
                }
            });
            $scope.closePopup();
            $loading.start('findJobs');

            const documents = [];
            if ($scope.document.w9) {
                documents.push('W9');
            }

            if ($scope.document.driverLicence) {
                documents.push('driverLicense');
            }

            if ($scope.document.resume) {
                documents.push('resume');
            }

            if ($scope.document.motorVehicleInsurance) {
                documents.push('vehicleInsurance');
            }

            if ($scope.document.liabilityInsurance) {
                documents.push('liabilityInsurance');
            }

            if ($scope.document.xRayDocumentShared) {
                documents.push('xRayDocument');
            }

            if ($scope.document.drugTestDocumentShared) {
                documents.push('drugTestDocument');
            }

            if ($scope.document.vaccinationShared) {
                documents.push('vaccination');
            }

            if (cert) {
                for (const item of cert) {
                    documents.push(`certifications.${item}`);
                }
            }

            if (addCert) {
                for (const item of addCert) {
                    documents.push(`additionalCertifications.${item}`);
                }
            }

            try {
                await JobsClientService.shareDocuments($localStorage['token'], shareDocementAppId, documents);
                $loading.finish('findJobs');
                toastr.success('Document Shared successfully.');
                $scope.allJobs[shareDocumentIndex].W9Shared = $scope.document.w9;
                $scope.allJobs[shareDocumentIndex].driverLicenseShared = $scope.document.driverLicence;
                $scope.allJobs[shareDocumentIndex].resumeShared = $scope.document.resume;
                $scope.allJobs[shareDocumentIndex].vehicleInsuranceShared = $scope.document.motorVehicleInsurance;
                $scope.allJobs[shareDocumentIndex].liabilityInsuranceShared = $scope.document.liabilityInsurance;
                $scope.allJobs[shareDocumentIndex].vaccinationShared = $scope.document.vaccinationShared;
                $scope.allJobs[shareDocumentIndex].drugTestDocumentShared = $scope.document.drugTestDocumentShared;
                $scope.allJobs[shareDocumentIndex].xRayDocumentShared = $scope.document.xRayDocumentShared;
                $scope.allJobs[shareDocumentIndex].certificationsShared = cert;
                $scope.allJobs[shareDocumentIndex].additionalCertificationsShared = addCert;
            }
            catch(err) {
                $loading.finish('findJobs');
                toastr.error(err.message);
            }

        };
        $scope.openJobDetail = function (index) {
            $scope.isFavourite = $scope.allJobs[index].hospital.isFavorite;
            var target = angular.element('#appliedJobsImg' + index);
            if (target.hasClass('arrow-image')) {
                target.removeClass('arrow-image');
                target.addClass('arrow-image-down');
            } else {
                target.removeClass('arrow-image-down');
                target.addClass('arrow-image');
            }

            $('.arrow-image-down').not('#appliedJobsImg' + index).removeClass('arrow-image-down').addClass('arrow-image');
            $('.close-job').not('#appliedJobsDetails' + index).removeClass('in');

        };
        $scope.sortByRate = function () {
            $scope.sortReverse = !$scope.sortReverse;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse);
        };
        $scope.sortByDate = function () {
            $scope.sortReverse2 = !$scope.sortReverse2;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType2);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse2);
        };
        /* Set job as favorite */
        $scope.updateFavourite = async function (data) {
            var token = $localStorage['token'];
            try {
                await JobsClientService.favorite(token, data.job.id);
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            }
            catch(err) {
                toastr.error(err.message);
            }
        }

    }
]);

App.controller('scheduleJobsCtrl', ['$rootScope', '$scope', '$localStorage', '$sessionStorage', '$http', 'ngDialog', '$timeout', 'toastr', 'Api', '$q', 'commonService', '$document', '$loading', '$filter', 'printNurseBadge', 'JobsClientService',
    function ($rootScope, $scope, $localStorage, $sessionStorage, $http, ngDialog, $timeout, toastr, Api, $q, commonService, $document, $loading, $filter, printNurseBadge, JobsClientService) {
        /* All Varibale delaration */
        var dialogId;
        var limitPerPage = 8;
        var skip = 0;
        var cancelJobId;
        $scope.skip = 0;
        $scope.jobCount;
        $scope.jobOpen = false;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            limitPerPage: 8
        };
        $scope.sortType = 'newRate'; // set the default sort type
        $scope.sortReverse = false; // set the default sort order
        $scope.sortType2 = 'newStartDate'; // set the default sort type
        $scope.sortReverse2 = false; // set the default sort order
        $scope.$on('scheduleJobs', function (event, args) {
            $scope.pagination.currentPage = 0;
            $scope.skip = 0;
            $loading.start('findJobs');
            $scope.searchAllJobs(skip,$scope.pagination.limitPerPage);
        });
        /* Get All jobs Api */
        $scope.searchAllJobs = async function (skip, limitPerPage) {
            let options = {
                limit: limitPerPage,
                skip: skip,
                status: 'UPCOMING'
            };

            const allJobs = [];
            let endTimeBufferMinutes = 0;
            try {
                endTimeBufferMinutes = (await JobsClientService.settings($localStorage['token'])).endTimeBufferMinutes;
            }
            catch(e) {
                console.error(e);
            }
            try {
                const result = await JobsClientService.listV1($localStorage['token'], options, endTimeBufferMinutes, ($localStorage['userId'] || ''), ($localStorage['userType'] || ''));
                if (result && result.count) {
                    $scope.jobCount = result.count;
                    for (let i = 0; i < result.list.length; i++) {

                        let job = result.list[i]
                        job.chatEnabled = 0;
                        job.canDelegate = 0;
                        job.canEdit = 1;
                        job.showRate = 1;

                        var newRate = job.rateType == 'FLAT' ? job.rate : job.shiftLength * job.rate;
                        job['newRate'] = parseInt(newRate);
                        job['newStartDate'] = $filter('date')(job.startDate, "MM/dd/yyyy h:mm a");
                        job['nursePool'] = (job.isMarketplace && job.isPRN) ? 'Both' : (job.isMarketplace ? 'Marketplace' : (job.isPRN ? 'PRNs' : 'Marketplace'));
                        job.rateType = $scope.convertRateFrequency(job.rateType);
                        job['isDateSelected'] =  job.isDateSelected;
                        if (job.type == 'Permanent') {
                            job.shiftLength = job.shiftLength;
                        } else if (job.type == 'Per diem') {
                            job.shiftLength = (job.shiftLength > 1) ? job.shiftLength+' hrs' : job.shiftLength+' hr' ;
                        } else {
                            job.shiftLength = job.shiftLength +' '+ job.durationUnit;
                        }

                        allJobs.push(job);
                    }
                }
                $scope.allJobs = allJobs;
                $loading.finish('findJobs');
            }
            catch(err) {
                $loading.finish('findJobs');
                toastr.error(err.message);
            }
            finally {
                $scope.$applyAsync();
            }

        }

        $scope.pageChanged = function (currentPage) {
            $loading.start('findJobs');
            if (currentPage != 0) {
                $scope.skip = (currentPage - 1) * limitPerPage;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            } else {
                $scope.skip = 0;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            }

        }
        /* Apply job */
        $scope.confirmFirstCanceljob = function (id) {
            cancelJobId = id;
            dialogId = ngDialog.open({
                template: 'edit-confirm-dialog',
                className: 'ngdialog-theme-default',
                closeByNavigation: true,
                showClose: false,
                scope: $scope
            });
        }

        /* Apply job */
        $scope.confirmSecondCanceljob = function () {
            dialogId.close();
            dialogId = ngDialog.open({
                template: 'second-edit-confirm-dialog',
                className: 'ngdialog-theme-default',
                closeByNavigation: true,
                showClose: false,
                scope: $scope
            });
        }
        $scope.cancelJob = function (currentPage) {
            $scope.closePopup();
            $loading.start('findJobs');
            let jobId = cancelJobId.split('-')[0];
            let professionalId = cancelJobId.split('-')[1];

            JobsClientService.cancel($localStorage['token'], jobId, professionalId)
                .then(function (res) {
                    $loading.finish('findJobs');
                    var diff = $scope.jobCount - $scope.skip;
                    if (diff == 1 && $scope.jobCount > 1) {
                        $scope.skip = ($scope.pagination.currentPage - 2) * limitPerPage;
                        $scope.pagination.currentPage = $scope.pagination.currentPage - 1;
                    } else {
                        if ($scope.pagination.currentPage != 0) {
                            $scope.skip = ($scope.pagination.currentPage - 1) * limitPerPage;
                        } else {
                            $scope.skip = 0;
                        }
                    }
                    $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
                    toastr.success('Job has been cancelled');
                })
                .catch(function (err) {
                    $loading.finish('findJobs');
                    toastr.error(err.message);
                })
        }
        
        $scope.closePopup = function () {
            ngDialog.close(dialogId);
        }
        $scope.openJobDetail = function (index) {
            var target = angular.element('#scheduleJobsImg' + index);
            if (target.hasClass('arrow-image')) {
                target.removeClass('arrow-image');
                target.addClass('arrow-image-down');
            } else {
                target.removeClass('arrow-image-down');
                target.addClass('arrow-image');
            }

            $('.arrow-image-down').not('#scheduleJobsImg' + index).removeClass('arrow-image-down').addClass('arrow-image');
            $('.close-job').not('#scheduleJobsDetails' + index).removeClass('in');

        }

        $scope.sortByRate = function () {
            $scope.sortReverse = !$scope.sortReverse;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse);
        };
        $scope.sortByDate = function () {
            $scope.sortReverse2 = !$scope.sortReverse2;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType2);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse2);
        };

        //=====print nurse badge=========
        $scope.PrintBadge = function (data) {
            printNurseBadge.print(data);
        }

    }
]);

App.controller('historyJobsCtrl', ['$rootScope', '$scope', '$localStorage', '$http', 'ngDialog', '$timeout', 'toastr', 'Api', '$q', 'commonService', '$document', '$loading', '$filter', 'JobsClientService',
    function ($rootScope, $scope, $localStorage, $http, ngDialog, $timeout, toastr, Api, $q, commonService, $document, $loading, $filter, JobsClientService) {
        /* All Varibale delaration */
        var dialogId;
        var limitPerPage = 8;
        var skip = 0;
        $scope.skip = 0;
        $scope.jobCount;
        $scope.jobOpen = false;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            limitPerPage: 8
        };
        $scope.sortType = 'newRate'; // set the default sort type
        $scope.sortReverse = false; // set the default sort order
        $scope.sortType2 = 'newStartDate'; // set the default sort type
        $scope.sortReverse2 = false; // set the default sort order
        $scope.$on('historyJobs', function (event, args) {
            $scope.pagination.currentPage = 0;
            $scope.skip = 0;
            $scope.searchAllJobs(skip, $scope.pagination.limitPerPage);
        });
        /* Get All jobs Api */
        $scope.searchAllJobs = async function (skip, limitPerPage) {
            let options = {
                limit: limitPerPage,
                skip: skip,
                status: 'HISTORY'
            };

            const allJobs = [];
            let endTimeBufferMinutes = 0;
            try {
                endTimeBufferMinutes = (await JobsClientService.settings($localStorage['token'])).endTimeBufferMinutes;
            }
            catch(e) {
                console.error(e);
            }
            try {
                const result = await JobsClientService.listV1($localStorage['token'], options, endTimeBufferMinutes, ($localStorage['userId'] || ''), ($localStorage['userType'] || ''));
                if (result && result.count) {
                    $scope.jobCount = result.count;
                    for (let i = 0; i < result.list.length; i++) {

                        let job = result.list[i]
                        job.chatEnabled = 0;
                        job.canDelegate = 0;
                        job.canEdit = 1;
                        job.showRate = 1;

                        var newRate = job.rateType == 'FLAT' ? job.rate : job.shiftLength * job.rate;
                        job['newRate'] = parseInt(newRate);
                        job['newStartDate'] = $filter('date')(job.startDate, "MM/dd/yyyy h:mm a");
                        job['nursePool'] = (job.isMarketplace && job.isPRN) ? 'Both' : (job.isMarketplace ? 'Marketplace' : (job.isPRN ? 'PRNs' : 'Marketplace'));
                        job.rateType = $scope.convertRateFrequency(job.rateType);
                        job['isDateSelected'] =  job.isDateSelected;
                        if (job.type == 'Permanent') {
                            job.shiftLength = job.shiftLength;
                        } else if (job.type == 'Per diem') {
                            job.shiftLength = (job.shiftLength > 1) ? job.shiftLength+' hrs' : job.shiftLength+' hr' ;
                        } else {
                            job.shiftLength = job.shiftLength +' '+ job.durationUnit;
                        }

                        allJobs.push(job);
                    }
                }
                $scope.allJobs = allJobs;
                $loading.finish('findJobs');
            }
            catch(err) {
                $loading.finish('findJobs');
                toastr.error(err.message);
            }
            finally {
                $scope.$applyAsync();
            }

        }
        $scope.pageChanged = function (currentPage) {
            if (currentPage != 0) {
                $scope.skip = (currentPage - 1) * limitPerPage;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            } else {
                $scope.skip = 0;
                $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
            }
            $scope.searchAllJobs($scope.skip, $scope.pagination.limitPerPage);
        }

        $scope.openJobDetail = function (index) {
            var target = angular.element('#historyJobsImg' + index);
            if (target.hasClass('arrow-image')) {
                target.removeClass('arrow-image');
                target.addClass('arrow-image-down');
            } else {
                target.removeClass('arrow-image-down');
                target.addClass('arrow-image');
            }

            $('.arrow-image-down').not('#historyJobsImg' + index).removeClass('arrow-image-down').addClass('arrow-image');
            $('.close-job').not('#historyJobsDetails' + index).removeClass('in');

        }

        $scope.sortByRate = function () {
            $scope.sortReverse = !$scope.sortReverse;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse);
        };
        $scope.sortByDate = function () {
            $scope.sortReverse2 = !$scope.sortReverse2;
            var orderByExpression = [];
            orderByExpression.push($scope.sortType2);
            $scope.allJobs = $filter('orderBy')($scope.allJobs, orderByExpression, $scope.sortReverse2);
        };

    }
]);
